var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

import ContextFactory from "../Context";
var DEFAULT_STATE = {
  overlay: null,
  isOverlayLoaded: false,
  videoState: null,
  playerDimensions: null,
  scale: null
};
var PlayerContext = (_temp = _class = function () {
  function PlayerContext(propagateMutation) {
    var _this = this;

    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _extends({}, DEFAULT_STATE);

    _classCallCheck(this, PlayerContext);

    _initialiseProps.call(this);

    this.state = state;

    this._propagateMutation = function () {
      propagateMutation(_this);
    };
  }

  PlayerContext.prototype._triggerPauseEvent = function _triggerPauseEvent(state) {
    if (this.onPause) {
      var isCurrentlyPaused = this.state.videoState ? this.state.videoState.paused : true;

      if (!isCurrentlyPaused && state.paused) {
        this.onPause(state.currentTime, state.autoPaused);
      }
    }
  };

  PlayerContext.prototype._triggerPlayEvent = function _triggerPlayEvent(state) {
    if (this.onPlay) {
      var isCurrentlyPlaying = this.state.videoState ? !this.state.videoState.paused : false;

      if (!isCurrentlyPlaying && !state.paused) {
        this.onPlay(state.currentTime);
      }
    }
  };

  PlayerContext.prototype._triggerVideoPropsReceived = function _triggerVideoPropsReceived(state) {
    if (this.onVideoPropsReceived && this.state.videoState && this.state.videoState.duration !== state.duration) {
      this.onVideoPropsReceived({
        duration: state.duration,
        width: state.videoWidth,
        height: state.videoHeight
      });
    }
  };

  PlayerContext.prototype._triggerTimeChanged = function _triggerTimeChanged(state) {
    if (this.onTimeChanged && this.state.videoState && this.state.videoState.currentTime !== state.currentTime) {
      this.onTimeChanged(state.currentTime, state.seeking);
    }
  };

  return PlayerContext;
}(), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setState = function (newState) {
    Object.keys(newState).map(function (key) {
      return _this2.state[key] = newState[key];
    });

    _this2._propagateMutation();
  };

  this.initializeState = function (state) {
    var onResize = state.onResize,
        onPause = state.onPause,
        onPlay = state.onPlay,
        onScaleChange = state.onScaleChange,
        onVideoPropsReceived = state.onVideoPropsReceived,
        onTimeChanged = state.onTimeChanged,
        restProps = _objectWithoutProperties(state, ["onResize", "onPause", "onPlay", "onScaleChange", "onVideoPropsReceived", "onTimeChanged"]);

    _this2.onResize = onResize;
    _this2.onPause = onPause;
    _this2.onPlay = onPlay;
    _this2.onScaleChange = onScaleChange;
    _this2.onVideoPropsReceived = onVideoPropsReceived;
    _this2.onTimeChanged = onTimeChanged;

    _this2.setState(_extends({}, DEFAULT_STATE, restProps));
  };

  this.setVideoState = function (state) {
    _this2._triggerPauseEvent(state);

    _this2._triggerPlayEvent(state);

    _this2._triggerVideoPropsReceived(state);

    _this2._triggerTimeChanged(state);

    _this2.setState({
      videoState: state
    });

    _this2.refreshVideoScale();
  };

  this.setDimensions = function (width, height) {
    _this2.setState({
      playerDimensions: {
        width: width,
        height: height
      }
    });

    _this2.refreshVideoScale();

    if (_this2.onResize) {
      _this2.onResize(width, height);
    }
  };

  this.refreshVideoScale = function () {
    var _state = _this2.state,
        scale = _state.scale,
        videoState = _state.videoState,
        playerDimensions = _state.playerDimensions;

    if (!videoState || !playerDimensions || videoState.readyState === 0) {
      return;
    }

    var videoWidth = videoState.videoWidth,
        videoHeight = videoState.videoHeight;
    var width = playerDimensions.width,
        height = playerDimensions.height;
    var scaleX = width / videoWidth;
    var scaleY = height / videoHeight;
    var newScale = Math.min(scaleX, scaleY);

    if (newScale !== scale) {
      _this2.setState({
        scale: newScale
      });

      if (_this2.onScaleChange) {
        _this2.onScaleChange(newScale);
      }
    }
  };

  this.reportOverlayLoaded = function () {
    _this2.setState({
      isOverlayLoaded: true
    });
  };
}, _temp);

var _ContextFactory = ContextFactory(PlayerContext, "PlayerContext"),
    withProvider = _ContextFactory.withProvider,
    consumeContext = _ContextFactory.consumeContext;

export { withProvider, consumeContext };